import React, { useState } from "react"
import { Modal } from "antd"
//graph
import GroupedBarChart from "../charts/barChart/groupedBarChart/GroupedBarChart"
import LineChart from "../charts/lineChart/LineChart"
import ProjectionLineChart from "../charts/projectionLineChart/ProjectionLineChart"
import TargetBarChart from "../charts/targetBarChart/TargetBarChart"
import Heatmap from "../charts/heatmapChart/Heatmap"
//images
import graphPlaceholder from "../../../../images/jarvis/png/graph_placeholder.png"
import graphPlaceholder1 from "../../../../images/jarvis/png/graph_placeholder_1.png"

const RenderGraph = ({ id, title, data }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const openModal = () => {
        setIsModalOpen(true)
    }

    const closeModal = () => {
        setIsModalOpen(false)
    }

    const getImage = () => {
        if (id === 'astra_completion_count_history30' || id === 'datewise_service_count') {
            return graphPlaceholder
        } else {
            return graphPlaceholder1
        }
    }

    return (
        <>
            <style>
                {`
                    .ant-modal-content {
                        height: 90vh !important;
                        position: relative !important;
                        background-color: #151515 !important;
                        background-clip: padding-box !important;
                        border: 0 !important;
                        border-radius: 8px !important;
                        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
                            0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05) !important;
                        pointer-events: auto !important;
                        padding: 10px !important;
                    }
                    .ant-modal-body {
                        overflow-y: auto;
                        height: 100%;
                    }
                    .ant-modal {
                        top: 10px !important;
                        overflow: hidden;
                        padding: 10px !important;
                    }

                    .ant-modal-close {
                        position: absolute;
                        top: 12px;
                        inset-inline-end: 12px;
                        z-index: 1010;
                        padding: 0;
                        color: rgb(255, 255, 255) !important;
                        font-weight: 600;
                        line-height: 1;
                        text-decoration: none;
                        background: #686868 !important;
                        border-radius: 4px;
                        width: 32px;
                        height: 32px;
                        border: 0;
                        outline: 0;
                        cursor: pointer;
                        transition: color 0.2s, background-color 0.2s;
                    }
                    .ant-modal-wrap {
                        inset: 0;
                        z-index: 1000;
                        overflow: auto;
                        outline: 0;
                        max-width: 550px;
                        position: fixed;
                    }
                `}
            </style>
            <div>
                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        height: "300px",
                        backgroundImage: `url(${getImage()})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            color: "white",
                            fontSize: "14px",
                            fontWeight: "bold",
                            cursor: "pointer",
                        }}
                        onClick={openModal}
                    ></div>
                </div>

                <Modal
                    title={title}
                    open={isModalOpen}
                    onCancel={closeModal}
                    footer={null}
                    style={{
                        maxWidth: "100%",
                        width: "550px",
                        marginLeft: "auto",
                        marginRight: "auto",
                    }}
                >
                    {(() => {
                        if (id === 'astra_completion_count_history30' || id === 'datewise_service_count') {
                            return <Heatmap graph_id={id} graph_title={title} graph_data={data} />
                        } else if (id === 'sale_vs_target_daily' || id === 'retailers_active_vs_target_daily') {
                            return <LineChart graph_id={id} graph_title={title} graph_data={data} />;
                        } else if (
                            id === 'retailer_sale_vs_das' ||
                            id === 'retailer_das_inactive' ||
                            id === 'retailer_sale_top5' ||
                            id === 'daily_points_curr_month' ||
                            id === 'daily_points_prev_month' ||
                            id === 'monthwise_points_curr_year' ||
                            id === 'monthwise_points_prev_year' ||
                            id === 'monthwise_comparison_curr_and_prev_year'
                        ) {
                            return <GroupedBarChart graph_id={id} graph_title={title} graph_data={data} />;
                        } else if (
                            id === 'daily_points_progress_comp_yoy' ||
                            id === 'daily_points_progress_curr_year' ||
                            id === 'daily_points_progress_proj_cs' ||
                            id === 'daily_points_progress_proj_10' ||
                            id === 'daily_points_progress_proj_25' ||
                            id === 'daily_points_progress_proj_40'
                        ) {
                            return <ProjectionLineChart graph_id={id} graph_title={title} graph_data={data} />;
                        } else if (id === 'services_vs_target_daily') {
                            return <TargetBarChart graph_id={id} graph_title={title} graph_data={data} />;
                        } else {
                            return <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "#fff"
                                }}
                            >
                                No chart available
                            </div>
                        }
                    })()}
                </Modal>
            </div>
        </>
    )
}

export default RenderGraph
